"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeleteOtaBuildPayload = exports.PatchOtaBuildPayload = exports.ReplaceOtaBuildPayload = exports.CreateOtaBuildPayload = exports.PublishOtaBuildPayload = exports.OtaBuildUniqueResult = exports.OtaBuildUrl = exports.OtaBuildList = exports.OtaBuild = void 0;
const effect_1 = require("effect");
const DeviceOta = __importStar(require("../../../../../device/ota"));
const field_1 = require("../../../../openapi/field");
const NAMESPACE = 'Culligan.Api.V1.Admin.Device.Schema';
const removedByUpdate = 'May be missing after PUT /ota/build/put or PATCH /ota/build/patch: fields omitted from the body are removed from the stored build.';
exports.OtaBuild = effect_1.Schema.Struct({
    id: effect_1.Schema.NonEmptyString,
    buildFile: effect_1.Schema.optionalWith(effect_1.Schema.NullOr(effect_1.Schema.NonEmptyString), { exact: true }).annotations({
        description: removedByUpdate,
    }),
    model: (0, field_1.optionalNullableString)(`V1 or V2 model code. ${removedByUpdate}`),
    version: (0, field_1.optionalNullableString)(removedByUpdate),
    minVersion: (0, field_1.optionalNullableString)(removedByUpdate),
    description: (0, field_1.optionalNullableString)(removedByUpdate),
    size: effect_1.Schema.Int.pipe(effect_1.Schema.nonNegative()),
    timestamp: effect_1.Schema.propertySignature(effect_1.Schema.Int).annotations({
        description: 'Unix timestamp (seconds).',
    }),
    enabled: effect_1.Schema.Boolean,
    userId: effect_1.Schema.NonEmptyString,
    createdAt: effect_1.Schema.String,
    updatedAt: effect_1.Schema.String,
    kind: effect_1.Schema.optionalWith(DeviceOta.Kind, { exact: true }),
}).annotations({
    identifier: `${NAMESPACE}.OtaBuild`,
});
exports.OtaBuildList = effect_1.Schema.Struct({ items: effect_1.Schema.Array(exports.OtaBuild) }).annotations({
    identifier: `${NAMESPACE}.OtaBuildList`,
});
exports.OtaBuildUrl = effect_1.Schema.Struct({ item: effect_1.Schema.String }).annotations({
    identifier: `${NAMESPACE}.OtaBuildUrl`,
});
exports.OtaBuildUniqueResult = effect_1.Schema.Struct({ id: effect_1.Schema.Boolean }).annotations({
    identifier: `${NAMESPACE}.OtaBuildUniqueResult`,
    description: 'true when the id is free to use.',
});
exports.PublishOtaBuildPayload = effect_1.Schema.Struct({
    model: effect_1.Schema.NonEmptyString,
    buildFile: effect_1.Schema.NonEmptyString,
    version: effect_1.Schema.NonEmptyString,
    minVersion: effect_1.Schema.optionalWith(effect_1.Schema.String, { exact: true }),
    description: effect_1.Schema.optionalWith(effect_1.Schema.String, { exact: true }),
}).annotations({
    identifier: `${NAMESPACE}.PublishOtaBuildPayload`,
});
exports.CreateOtaBuildPayload = effect_1.Schema.Struct({
    id: effect_1.Schema.NonEmptyString,
    model: effect_1.Schema.NonEmptyString,
    version: effect_1.Schema.NonEmptyString,
    minVersion: effect_1.Schema.optionalWith(effect_1.Schema.String, { exact: true }),
}).annotations({
    identifier: `${NAMESPACE}.CreateOtaBuildPayload`,
    description: 'id must be unique (used as the buildFile). description, if supplied, is silently dropped.',
});
exports.ReplaceOtaBuildPayload = effect_1.Schema.Struct({
    model: effect_1.Schema.NonEmptyString,
    version: effect_1.Schema.NonEmptyString,
    minVersion: effect_1.Schema.optionalWith(effect_1.Schema.String, { exact: true }),
}).annotations({
    identifier: `${NAMESPACE}.ReplaceOtaBuildPayload`,
    description: 'Unset optional fields are removed from the stored build (PUT overwrite semantics).',
});
exports.PatchOtaBuildPayload = effect_1.Schema.Struct({
    model: effect_1.Schema.optionalWith(effect_1.Schema.NonEmptyString, { exact: true }),
    version: effect_1.Schema.optionalWith(effect_1.Schema.NonEmptyString, { exact: true }),
    minVersion: effect_1.Schema.optionalWith(effect_1.Schema.String, { exact: true }),
}).annotations({
    identifier: `${NAMESPACE}.PatchOtaBuildPayload`,
    description: 'Despite the method name, this currently behaves like PUT: fields omitted from the body are removed from the stored build.',
});
exports.DeleteOtaBuildPayload = effect_1.Schema.Struct({
    id: effect_1.Schema.optionalWith(effect_1.Schema.NonEmptyString, { exact: true }),
}).annotations({
    identifier: `${NAMESPACE}.DeleteOtaBuildPayload`,
});
//# sourceMappingURL=schema.js.map